(ns net.kestec.mhda-pilgrimage.admin.cms.cms-events
  (:require
    [net.kestec.mhda-pilgrimage.db :as-alias db]
    [ajax.core :as ajax]
    [day8.re-frame.http-fx]
    [re-frame.core :as rf]
    ))


(rf/reg-event-fx
  ::admin-load-global-news
  (fn [{db :db} _]
    (println "::admin-load-global-news")
    {:http-xhrio [{:method          :get
                   :uri             (str "/api/news/global")
                   :response-format (ajax/json-response-format {:keywords? true})
                   :on-success      [::db/set! ::admin-globalNews]
                   :on-failure      [::db/log-error]}]}))

(rf/reg-event-fx
  ::admin-load-division-news
  (fn [{db :db} _]
    (println "::admin-load-division-news")
    {:http-xhrio [{:method          :get
                   :uri             (str "/api/news/division")
                   :response-format (ajax/json-response-format {:keywords? true})
                   :on-success      [::db/set! ::admin-divisionNews]
                   :on-failure      [::db/log-error]}]}))

(rf/reg-event-fx
  ::admin-load-team-news
  (fn [{db :db} _]
    (println "::admin-load-team-news")
    {:http-xhrio [{:method          :get
                   :uri             (str "/api/news/")
                   :response-format (ajax/json-response-format {:keywords? true})
                   :on-success      [::db/set! ::admin-teamNews]
                   :on-failure      [::db/log-error]}]}))


(rf/reg-event-fx
  ::admin-cms-load-setup
  (fn [_ _]
    {:dispatch-n [[::admin-load-global-news]
                  [::admin-load-division-news]
;                  [::admin-load-team-news]
                  ]}))



